<template>
  <div class="promotion-video">
    <div class="promotion-video__video-container">
      <TVideoPlayer :options="videoOptions"/>
    </div>
    <div class="promotion-video__title">{{ title }}</div>
    <div class="promotion-video__description">{{ description }}</div>
  </div>
</template>

<script>
import { TVideoPlayer } from '@/components/TVideoPlayer';

export default {
  name: 'PromotionMainVideo',
  components: { TVideoPlayer },
  props: {
    video: {
      type: Object,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    videoOptions() {
      const {
        video,
      } = this;

      return {
        autoplay: false,
        controls: true,
        sources: [
          {
            src: video.src,
            type: 'video/mp4',
          },
        ],
        poster: video.poster,
        fluid: true,
        aspectRatio: '16:9',
      };
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
@import "~@/assets/scss/mixins";

.promotion-video {
  margin-bottom: 32px;

  &__video-container {
    margin: 0 auto 32px auto;
    width: 327px;
    height: 245px;

    border-radius: 30px;
    overflow: hidden;

    @include media-lg() {
      margin: 0 auto 40px auto;
      width: 1136px;
      height: 639px;
    }
  }

  &__title {
    margin-bottom: 16px;

    font-size: 22px;
    line-height: 24px;
    font-weight: 500;
    color: var(--gray-1);

    @include media-lg() {
      font-size: 36px;
      line-height: 40px;
      font-weight: 600;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    color: var(--gray-3);

    @include media-lg() {
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
    }
  }
}

</style>
